import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_2b09a7d1-98b2-45b2-a3c9-7352c92f0ea0/artifacts/u77wg689_KGOB%20logo.PNG';

export default function Footer() {
  return (
    <footer className="bg-[#1A365D] text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <img 
              src={LOGO_URL} 
              alt="KohariGonzalez Oneyear&Brown" 
              className="h-12 w-auto"
            />
            <p className="text-sm text-slate-300">
              Professional IRS Peace-of-Mind Review services to protect your financial well-being.
            </p>
            <p className="text-xs text-[#00B4B4] font-semibold tracking-wide">
              LET'S TALK GROWTH®
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Us</h3>
            <div className="space-y-3">
              <a 
                href="tel:1-844-499-3355" 
                className="flex items-center gap-2 text-slate-300 hover:text-[#00B4B4] transition-colors"
              >
                <Phone className="h-4 w-4" />
                1-844-499-3355
              </a>
              <a 
                href="mailto:relief@kgob.com" 
                className="flex items-center gap-2 text-slate-300 hover:text-[#00B4B4] transition-colors"
              >
                <Mail className="h-4 w-4" />
                relief@kgob.com
              </a>
              <div className="flex items-start gap-2 text-slate-300">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  2740 East WT Harris Blvd, Suite 240<br />
                  Charlotte, NC 28213
                </span>
              </div>
            </div>
          </div>

          {/* Service */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Our Service</h3>
            <p className="text-sm text-slate-300">
              The IRS Peace-of-Mind Review provides comprehensive analysis of your IRS transcripts, 
              assessment of potential audit triggers, and a detailed action plan to protect your tax standing.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-600">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-400">
              © {new Date().getFullYear()} KohariGonzalez Oneyear&Brown, CPAs & Advisors. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#privacy" className="text-sm text-slate-400 hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="#terms" className="text-sm text-slate-400 hover:text-white transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
